import apiClient from "@/api/client";
import type { TaskCategory } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const taskCategoriesApi = {
  list: () =>
    apiClient.get<{ data: TaskCategory[] }>("/task-categories/").then(wrap),

  create: (data: { name: string; color: string }) =>
    apiClient.post<{ data: TaskCategory }>("/task-categories/", data).then(wrap),

  update: (id: string, data: Partial<{ name: string; color: string }>) =>
    apiClient.patch<{ data: TaskCategory }>(`/task-categories/${id}/`, data).then(wrap),

  delete: (id: string) => apiClient.delete(`/task-categories/${id}/`),

  setTaskCategory: (taskId: string, categoryId: string | null) =>
    apiClient
      .post<{ data: { my_category: { id: string; name: string; color: string } | null } }>(
        `/tasks/${taskId}/set-category/`,
        { category_id: categoryId },
      )
      .then(wrap),
};
